<div class="bulk-upload-main">
  <div class="bulk-upload-head">
    <span class="bulk-dispatch-timer">Bulk Dispatch</span>
    <div class="bulk-display-timer">
      <img src="./assets/images/timer-svgrepo-com.svg" alt="timer-img" class="timer-img filter-invert">
      <span class="carrier-text-alignment width-thirty bulk-dispatch-timer">{{displayTimer()}}</span>
    </div>
  </div>
  <div class="bulkupload-button">
    <!-- <button class="custom-button-compact p-button" (click)="save(2)" [disabled]="isDispatched">Save</button> -->
    <button class="custom-button-compact p-button" (click)="save(3)" [disabled]="isLoading || !form.valid || uploads.length < 3 || isDispatched || isPolicyExpired || isPolicyEmpty || !isTransitCompleteCarrier">Save as Dispatched</button>
    <button class="custom-button-compact p-button" (click)="sendAttachments()" [disabled]="isLoading || !isDispatched || isShareCarrierTerms">Share Carrier Terms</button>
    <button class="custom-button-compact p-button" (click)="sendDispatchedMail()" [disabled]="isLoading || !isDispatched || isSendNotification">Send Dispatch Notifications</button>
    <div class="link-button">
      <a class="muted7" [ngStyle]="isLoading ? {pointerEvents: 'none'} : ''" (click)="cancelClick()"><img src="./assets/images/close.svg" alt="close-img" class="filter-invert" /></a>
    </div>
  </div>
</div>
<div class="bulk-warning-msg">
  <div class="warning-red">
    <span *ngIf="isShowWarning && !isShareCarrierTerms" class="bulk-warning"><img src="./assets/images/alert.svg" alt="warning-img">Warning: Please Share carrier terms!</span>
    <span *ngIf="isShowWarning && !isSendNotification" class="bulk-warning"><img src="./assets/images/alert.svg" alt="warning-img">Warning: Please Send Dispatch Notifications!</span>
  </div>
  <span *ngIf="isShowWarning && isSendNotification && isShareCarrierTerms" class="bulk-success-green">This bulk dispatch is now complete, you may
    exit this screen</span>
</div>
<!-- <div  *ngIf="isLoading" class="bulk-upload-loader">
  <loading></loading>
</div> -->
<ng-container>
  <form  [formGroup]="form">
    <div *ngIf="!isLoading" class="row m-0 bulk-upload-form">
      <div class="col-4 upload-bulk-border">
          <div class="bulk-flex">
            <div class="carrier-text-alignment width-thirty py-1 pr-2">{{metadata['assignedCarrier']}}</div>
            <div class="dispatch-page-width">

              <p-autoComplete dataKey="value" [formControl]="form.get('selectedCarrier')" field="label"
                inputStyleClass="simple-control" [suggestions]="carrierItems" [style]="{'width': '100%'}" appendTo="body"
                (completeMethod)="carrierSearch($event)" (onSelect)="carrierSelect($event.value)" (onClear)="onClearCarrier()"
                forceSelection="true"></p-autoComplete>
              <dynamic-control-error [formControl]="form.get('selectedCarrier')" [controlName]="'Carrier'"
                ngDefaultControl></dynamic-control-error>

              <div class="carrier-warning-message"  *ngIf="!hasActiveDriver && form.get('selectedCarrier').value && isNewRecordForTruckOverhual">
                <img src="./assets/images/alert.svg" alt="alert-img" />
                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block">Please select another carrier. This has no active
                  driver.
                </div>
              </div>

              <div class="carrier-warning-message" *ngIf="!isTransitCompleteCarrier && form.get('selectedCarrier').value">
                <img src="./assets/images/alert.svg" alt="alert-img" />
                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block"> This carrier is not marked as Profile Complete. Please mark it or use another carrier. </div>
              </div>

              <div class="carrier-warning-message" *ngIf="isPolicyExpired && form.get('selectedCarrier').value">
                <img src="./assets/images/alert.svg" alt="alert-img" />
                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block"> The carrier
                  policy has expired. Please select another carrier. </div>
              </div>

              <div class="carrier-warning-message" *ngIf="isPolicyEmpty && form.get('selectedCarrier').value">
                <img src="./assets/images/alert.svg" alt="alert-img" />
                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block"> Please select
                  another carrier. This carrier has no policy attached.</div>
              </div>

              <div class="small-text italic" style="color:#b00; text-align: right; width: 100%; display: inline-block"
                *ngIf="(form.controls['assignedCarrier']?.errors && form.controls['assignedCarrier']?.errors?.incorrect) || isDoNotUseCarrier">
                <ng-container>
                  <div class="carrier-warning-message justify-content-start">
                  <img src="./assets/images/alert.svg" alt="alert-img"/>
                  <div *ngIf="!isDoNotUseCarrier">{{form.controls['assignedCarrier']?.errors?.incorrect}}</div>
                  <div *ngIf="isDoNotUseCarrier">Please select another carrier. This carrier mark as do not use.</div>
                </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="bulk-flex">
            <div class="width-thirty pr-2">MC #</div>
            <div class="dispatch-page-width">
              <span></span> {{mcNumber}}
            </div>
          </div>
          <div class="bulk-flex">
            @if (policyDetails.length > 0) {
            <table class="width-hundred">
              @for (policy of policyDetails; track $index; let last = $last) {
              <tr>
                <td colspan="4" class="policy-details-wrapper" [class.last-policy]="last">
                  <div class="broker-fee-width">
                    <b> {{ policy.policyName }}</b>
                  </div>
                  <div class="policy-details-section">
                    @for (cargo of policy.cargoLimit; track $index) {
                    <div class="d-flex">
                      <div class="policy-details-label">
                        ${{ cargo.cargoInsuranceLimit | number:'1.2-2' }} ;
                        @if (cargo.cargoInsuranceDeductible) {
                        ${{ cargo.cargoInsuranceDeductible | number:'1.2-2' }}
                        } @else {
                        <span class="td-dynamic-data">—</span>
                        }
                      </div>
                      <div [ngStyle]="{ color: cargo.isCargoInsuranceLimitExpire ? 'var(--dynamic-error)' : (cargo.isCargoInsuranceLimitAboutToExpire ? 'var(--dynamic-warning)' : 'var(--body-color)') }">
                        Exp. {{ cargo.insuranceExpirationDate | date:'MM/dd/yy' :'UTC' }}
                        @if (cargo.isCargoInsuranceLimitExpire) {
                        <span style="color: var(--dynamic-error); font-style: italic;"> Policy
                          Expired</span>
                        } @else if (cargo.isCargoInsuranceLimitAboutToExpire) {
                        <span style="color: var(--dynamic-warning); font-style: italic;"> Policy
                          About to Expire</span>
                        }
                      </div>
                    </div>
                    }
                    @for (liability of policy.liabilityLimit; track $index) {
                    <div class="d-flex">
                      <div class="policy-details-label">
                        ${{ liability.liabilityLimit | number:'1.2-2' }}
                      </div>
                      <div [ngStyle]="{ color: liability.isLiabilityLimitExpire  ? 'var(--dynamic-error)' : (liability.isLiabilityLimitAboutToExpire ? 'var(--dynamic-warning)' : 'var(--body-color)') }">
                        Exp. {{ liability.liabilityExpirationDate | date:'MM/dd/yy':'UTC' }}
                        @if (liability.isLiabilityLimitExpire) {
                        <span style="color: var(--dynamic-error); font-style: italic;">
                          Policy Expired</span>
                        } @else if (liability.isLiabilityLimitAboutToExpire) {
                        <span style="color: var(--dynamic-warning); font-style: italic;">
                          Policy About to Expire</span>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </td>
              </tr>
              }
            </table>
            } @else {
              <table class="width-hundred">
                <tr>
                  <td class="carrier-text-alignment">Policy Details  — — </td>
                </tr>
              </table>
            }
          </div>
      </div>
      <div class="col-4 upload-bulk-border">
        <div class="bulk-flex">
          <div class="carrier-text-alignment pr-2">{{metadata['dispatcherName']}}</div>
          <div class="dispatch-page-width">
            <simple-control [form]="form" key="dispatcherName" [label]="metadata['dispatcherName']"
              type="text"></simple-control>
          </div>
        </div>
        <div class="bulk-flex">
          <div class="carrier-text-alignment pr-2">{{metadata['dispatcherPhone']}}</div>
          <div class="dispatch-page-width">
            <simple-control [form]="form" key="dispatcherPhone" [label]="metadata['dispatcherPhone']"
              type="phone"></simple-control>
          </div>
        </div>
        <div class="bulk-flex">
          <td class="carrier-text-alignment pr-2">{{metadata['dispatcherEmail']}}</td>
          <td class="dispatch-page-width">
            <simple-control [form]="form" key="dispatcherEmail" [label]="metadata['dispatcherEmail']"
              type="email"></simple-control>
          </td>
        </div>
      </div>
      <div class="col-4 upload-bulk-border align-items-start">
        <div class="bulk-flex">
          <div class="carrier-text-alignment width-thirty py-1 pr-2">{{metadata['paymentTerms']}}</div>
          <div class="dispatch-page-width">
            <simple-control [form]="form" key="paymentTerms" [label]="metadata['paymentTerms']" type="lookup"
              [items]="lookups.paymentTerms"></simple-control>
          </div>
        </div>
        <div class="bulk-flex">
          <div class="width-thirty py-1 pr-2">Additional Carrier Emails</div>
          <div class="dispatch-page-width">
            <div formArrayName="carrierEmails" class="width-hundred">
              <div *ngFor="let c of form.get('carrierEmails')?.controls; let i=index">
                <div class="padding-top-zero">
                  <div class="pickup-phones">
                    <input appSanitizeInput [formControlName]="i" [id]="key" pInputText type="text"
                      [(ngModel)]="c.value" autocomplete="off"
                      class="simple-control bulk-upload-input" />
                    <span><a (click)="confirmDelete(i)" class="link-button"
                        style="font-size: 16px; color: maroon !important" [ngStyle]="isDispatched ? {pointerEvents: 'none'} : ''">&nbsp;X</a></span>
                  </div>
                  <dynamic-control-error [formControl]="c" [controlName]="'Carrier Email'"
                    ngDefaultControl></dynamic-control-error>
                  <div *ngIf="c?.errors?.pattern"> <span style="font-size: 0.85em; color: #b00!important"> * Email
                      is
                      not a valid email address </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="order-from-pd">
              <a (click)="addCarrierEmail()" class="link-button" [ngStyle]="isDispatched ? {pointerEvents: 'none'} : ''">+ Add Email</a>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isLoading" class="col-12 upload-bulk-border">
        <div id="order-form-carrier-phone-numbers" class="th-display-none"></div>
        <div class="bulk-flex">
          <div class="carrier-text-alignment bulk-carrier-spacing">Carrier Phone Numbers:</div>
          <div>
            <div class="carrier-phones">
              <div>
                <dynamic-value [type]="'phone'" [value]="businessPhone"></dynamic-value>
              </div>
              <div *ngFor="let p of assignedCarrierPhones">
                <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
              </div>
              <div>
                <dynamic-value [type]="'phone'" [value]="assignedCarrierPhone"></dynamic-value>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 upload-bulk-form">
      <div class="col-6 upload-bulk-border" [hidden]="isLoading">
        <div class="bulk-upload-overflow">
          <div class="small-text italic text-align-center"
            style="color:#b00; text-align: right; width: 100%; display: inline-block" *ngIf="uploads.length < 3">
            <ng-container>
              <img src="./assets/images/alert.svg" alt="alert-img"/>Please upload Dispatch profile page, ratings page and SAFER page.
            </ng-container>
          </div>
          <uploads [orderId]="0" [orderGuid]="null" (rowsChange)="changeUploads($event)" [addLabel]="'Add Attachments'" [isDispatched]="isDispatched"
            class="bulkupload-add-doc bulk-upload-attachment"></uploads>
        </div>
      </div>
      <div *ngIf="!isLoading" class="col-6 upload-bulk-border vertical-alignment-top">
        <div class="bulkupload-input-checkbox">
          <div class="bulkupload-option-checkbox">
            <input type="checkbox" [checked]="form.get('includeBoL')?.value"
              (change)="form.get('includeBoL')?.setValue(!form.get('includeBoL')?.value)" /> Include
            Bill of Lading&nbsp;&nbsp;
          </div>
          <div class="bulkupload-option-checkbox">
            <input type="checkbox" [checked]="form.get('includePort')?.value"
              (change)="form.get('includePort')?.setValue(!form.get('includePort')?.value)" />
            Include Port Additional Terms?
          </div>
          <div class="bulkupload-option-checkbox">
            <input type="checkbox" [checked]="form.get('includeRidgeville')?.value"
              (change)="form.get('includeRidgeville')?.setValue(!form.get('includeRidgeville')?.value)" />
            Include Ridgeville Additional Terms?
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="!isLoading" class="row m-0 bulkupload-sticky-header">
      <ng-container [formArrayName]="'bulkEditOrders'" *ngFor="let f of dynamicBulkUploadrray?.controls; let i = index;">
        <ng-container [formGroupName]="i">
          <div class="col-12 p-0 bulk-upload-dynamicfield">
            <div class="bulk-upload-editorder-list">
              <div class="bulk-order-number">
                <span class="bulk-uplaod-number">
                  Order {{modal[i]?.number}}
                </span>
                <span class="bulk-upload-code">
                  ({{modal[i]?.numVehicles}}) {{modal[i]?.pickupStateCode}} - {{modal[i]?.deliveryStateCode}}
                </span>
              </div>
              <div class="bulk-upload-editfield brokerfee-spacing">
                <span class="carrier-text-alignment width-hundred bulk-upload-spacing">{{metadata['brokerFee']}}</span>
                <span class="dispatch-page-width">
                  <simple-control *ngIf="f.get('brokerFee')?.value != null" [form]="f" key="brokerFee"
                    [label]="metadata['brokerFee']" type="currency" [readonly]="true"></simple-control>
                  <div *ngIf="f.get('brokerFee')?.value == null" style="padding: 4px;">N/A</div>
                </span>
              </div>
              <div class="bulk-upload-editfield">
                <span
                  class="carrier-text-alignment width-hundred bulk-upload-spacing">{{metadata['brokerFeePaid']}}</span>
                <span class="dispatch-page-width">
                  <simple-control [form]="f" key="brokerFeePaid" [label]="metadata['brokerFeePaid']"
                    (onChange)="setBrokerFeePaidAndMethod($event.value,f,i);calculateCompanyProfit(i)" type="lookup" [items]="lookups.yesNoNa"
                    [readonly]="f.get('brokerFee')?.value == null "></simple-control>
                </span>
              </div>
              <div *ngIf="f?.get('brokerFeePaid')?.value == YesNoNA.Yes" class="bulk-upload-editfield broker-fee-width">
                <span
                  class="carrier-text-alignment width-hundred bulk-upload-spacing">{{metadata['brokerFeePaidDate']}}</span>
                <span class="dispatch-page-width vertical-alignment-top">
                  <simple-control [form]="f" key="brokerFeePaidDate" [label]="metadata['brokerFeePaidDate']" type="date"
                    (onChange)="calculateCompanyProfit(i)"></simple-control>
                </span>
              </div>
              <div *ngIf="f?.get('brokerFeePaid')?.value == YesNoNA.Yes" class="bulk-upload-editfield broker-fee-width">
                <span
                  class="carrier-text-alignment width-hundred bulk-upload-spacing">{{metadata['brokerFeePaymentMethod']}}</span>
                <span class="dispatch-page-width vertical-alignment-top">
                  <simple-control [form]="f" key="brokerFeePaymentMethod" [label]="metadata['brokerFeePaymentMethod']"
                    type="lookup" [items]="lookups.paymentMethod" (onChange)="calculateCompanyProfit(i)">
                  </simple-control>
                </span>
              </div>
              <div *ngIf="f.get('desiredProfit')?.value?.length > 0" class="bulk-upload-editfield desiredProfit-width ml-2">
                <span class="carrier-text-alignment bulk-upload-spacing"
                  [style.background]="'rgba(250, 250, 0, 0.7)'" style="height: 38px;">{{metadata['desiredProfit']}}</span>
                <span class="dispatch-page-width vertical-alignment-top">
                  <simple-control [class]="'yellow-bg'" [label]="metadata['desiredProfit']" [form]="f" key="desiredProfit"
                    type="currency" [readonly]="true"></simple-control>
                </span>
              </div>
              <div class="bulk-upload-editfield">
                <span class="carrier-text-alignment width-hundred bulk-upload-spacing">Company Profit</span>
                <span class="dispatch-page-width vertical-alignment-top">
                  <simple-control [form]="f" key="calculatedCompanyProfit" label="Company Profit" type="currency"
                    [readonly]="true"></simple-control>
                </span>
              </div>
            </div>
            <div class="bulk-upload-editorder">
              <div *ngIf="f.get('number').value && f.get('number').value < truckOverhaulOrderNumber" class="truckoverhaulorder">
              <div class="bulk-upload-editfield">
                <span class="carrier-text-alignmen bulk-upload-spacing">{{metadata['driverName']}}</span>
                <span class="dispatch-page-width">
                  <simple-control simple-control [form]="f" key="driverName" [label]="metadata['driverName']" type="text">
                  </simple-control>
                </span>
              </div>
              <div class="bulk-upload-editfield">
                <span class="carrier-text-alignment bulk-upload-spacing">{{metadata['driverPhone']}}</span>
                <span class="dispatch-page-width">
                  <simple-control [form]="f" key="driverPhone" [label]="metadata['driverPhone']" type="phone">
                  </simple-control>
                </span>
              </div>
              <div class="bulk-upload-editfield">
                <span class="carrier-text-alignment bulk-upload-spacing">{{metadata['trailerSize']}}</span>
                <span class="dispatch-page-width vertical-alignment-top">
                  <simple-control [form]="f" key="trailerSize" [label]="metadata['trailerSize']" type="text">
                  </simple-control>
                </span>
              </div>
             </div>
             <div class="d-flex">
              <div *ngIf="f.get('number').value && f.get('number').value > truckOverhaulOrderNumber" class="carrier-text-alignment">
                <driver-truck-form [form]="f"  [formKey]="'orderDriverDetail'" [noOfRequireDateFields]="1" [type]="'bulkEdit'" [isDispatched]="isDispatched"  [carrierData]="form.get('selectedCarrier')?.value" (noActiveDriverFlagChange)="onNoActiveDriverFlagChange($event)" (policyData)="onPolicyDetailsChange($event)"></driver-truck-form>
              </div>
              <div class="bulk-upload-editfield" [ngClass]="{'bulk-field-width': f.get('number').value && f.get('number').value > truckOverhaulOrderNumber}">
                <span
                  class="carrier-text-alignment width-hundred bulk-upload-spacing">{{metadata['priceToCarrier']}}</span>
                <span class="dispatch-page-width">
                  <simple-control [form]="f" key="priceToCarrier" [label]="metadata['priceToCarrier']" type="currency"
                    (onChange)="calculatePriceToCarrier(i)"></simple-control>
                </span>
              </div>
              <div class="bulk-upload-editfield ml-3" [ngClass]="{'bulk-field-width': f.get('number').value && f.get('number').value > truckOverhaulOrderNumber}">
                <span class="carrier-text-alignment width-hundred bulk-upload-spacing">Price to carrier (Adjusted)</span>
                <span class="dispatch-page-width">
                  <simple-control [form]="f" key="calculatedPriceToCarrier" label="Price To Carrier (Adjusted)"
                    type="currency" [readonly]="true"></simple-control>
                </span>
              </div>
              <div>
                <div class="bulk-upload-editfield w-100" *ngIf="f.get('number').value && f.get('number').value > bookedDispatchOrderNumber">
                  <span class="carrier-text-alignment bulk-upload-spacing who-booked">{{metadata['whoBooked']}}</span>
                  <span class="dispatch-page-width who-booked-agents">
                    <simple-control [form]="f" key="whoBooked" [label]="metadata['whoBooked']" [filter]="true" type="lookup"
                      [items]="lookups.agents"></simple-control>
                  </span>
                </div>
                <div class="bulk-upload-editfield w-100" *ngIf="f.get('number').value && f.get('number').value > bookedDispatchOrderNumber">
                  <span class="carrier-text-alignment bulk-upload-spacing who-booked">{{metadata['bookedBy']}}</span>
                  <span class="dispatch-page-width who-booked-agents">
                    <simple-control [form]="f" key="bookedBy" [label]="metadata['bookedBy']" type="lookup"
                      [items]="lookups.bookedBy"></simple-control>
                  </span>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-6 upload-bulk-border vertical-alignment-top">
            <div class="bulk-flex align-items-center">
              <div class="text-align-start pickupdetails-bulk-width">{{metadata['customerExpectedPickup']}}</div>
              <div>
                <simple-control [label]="metadata['customerExpectedPickup']" [form]="f" key="customerExpectedPickup"
                  [readonly]="true" type="text"></simple-control>
              </div>
            </div>
            <div *ngIf="f.get('number').value && f.get('number').value > dateOverhaulOrderNumber">
              <div class="bulk-flex align-items-center" *ngFor="let customerExpectedPickupDate of f.get('customerExpectedPickupDates')?.value; let i = index;">
                <div class="carrier-text-alignment pickupdetails-bulk-width">{{metadata['customerExpectedPickupDates']}}
                  {{i+1}}
                </div>
                <div class="date-overhaul-spacing carrier-text-alignment bulk-flex">
                  <ng-container *ngIf="customerExpectedPickupDate.startDate; else dash">
                    {{customerExpectedPickupDate.startDate}}
                  </ng-container>
                  <ng-template #dash>
                    <span class="td-dynamic-data">
                      —
                    </span>
                  </ng-template>
                  <span *ngIf="customerExpectedPickupDate.dateType == 2"> -
                    <ng-container *ngIf="customerExpectedPickupDate.endDate; else dash">
                      {{customerExpectedPickupDate.endDate}}
                    </ng-container>
                    <ng-template #dash>
                      <span class="td-dynamic-data">
                        —
                      </span>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 upload-bulk-border vertical-alignment-top">
            <div class="bulk-flex align-items-center">
              <div class="customer-expected-delivery field-spacing pickupdetails-bulk-width carrier-text-alignment dateformat-label-width">
                {{metadata['customerExpectedDelivery']}}</div>
              <div>
                <simple-control [label]="metadata['customerExpectedDelivery']" [form]="f" key="customerExpectedDelivery"
                  type="text" [readonly]="true"></simple-control>
              </div>
            </div>
            <ng-container *ngIf="f.get('number').value <= orderConfirmDeliveryNumber">
              <div class="bulk-flex" *ngIf="f.get('number').value && f.get('number').value > dateOverhaulOrderNumber">
                <div class="carrier-text-alignment">
                  <dynamic-date-form [form]="f" [class]="'parallel-radio-btn'" [entityId]="f.get('orderId').value" [isDispatched]="isDispatched"
                    [label]="metadata['customerExpectedDeliveryDates']" [formKey]="'customerExpectedDeliveryDates'"
                    [noOfRequireDateFields]="0">
                  </dynamic-date-form>
                </div>
              </div>
            </ng-container>
            <ng-container  *ngIf="f.get('number').value > orderConfirmDeliveryNumber">
                <div *ngIf="f.get('number').value && f.get('number').value > dateOverhaulOrderNumber">
              <div class="bulk-flex align-items-center" *ngFor="let customerExpectedDeliveryDate of f.get('customerExpectedDeliveryDates')?.value; let i = index;">
                <div class="carrier-text-alignment pickupdetails-bulk-width">{{metadata['customerExpectedDeliveryDates']}}
                  {{i+1}}
                </div>
                <div class="date-overhaul-spacing carrier-text-alignment bulk-flex">
                  <ng-container *ngIf="customerExpectedDeliveryDate.startDate; else dash">
                    {{customerExpectedDeliveryDate.startDate}}
                  </ng-container>
                  <ng-template #dash>
                    <span class="td-dynamic-data">
                      —
                    </span>
                  </ng-template>
                  <span *ngIf="customerExpectedDeliveryDate.dateType == 2"> -
                    <ng-container *ngIf="customerExpectedDeliveryDate.endDate; else dash">
                      {{customerExpectedDeliveryDate.endDate}}
                    </ng-container>
                    <ng-template #dash>
                      <span class="td-dynamic-data">
                        —
                      </span>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
            </ng-container>
          </div>
          <div class="col-6 upload-bulk-border vertical-alignment-top">
            <div *ngIf="f.get('number').value && f.get('number').value > dateOverhaulOrderNumber" class="carrier-text-alignment bulk-flex">
                <dynamic-date-form [form]="f" [class]="'parallel-radio-btn'" [entityId]="f.get('orderId').value" [isDispatched]="isDispatched"
                  [label]="metadata['carrierScheduledPickupDates']"
                  [formKey]="'carrierScheduledPickupDates'"></dynamic-date-form>
            </div>
            <div class="new-records-main bulk-flex">
              <div class="carrier-pickup-datenote carrier-text-alignment pickupdetails-bulk-width py-1">
                {{metadata['scheduledPickup']}}</div>
              <div class="carrier-pickup-datenote-key dispatch-page-width">
                <simple-control [form]="f" key="scheduledPickup" [label]="metadata['scheduledPickup']"
                  type="text"></simple-control>
              </div>
            </div>
          </div>
          <div class="col-6 upload-bulk-border vertical-alignment-top">
            <div *ngIf="f.get('number').value && f.get('number').value > dateOverhaulOrderNumber" class="carrier-text-alignment bulk-flex">
                <dynamic-date-form [form]="f" [class]="'parallel-radio-btn'" [entityId]="f.get('orderId').value" [isDispatched]="isDispatched"
                  [label]="metadata['carrierScheduledDeliveryDates']"
                  [formKey]="'carrierScheduledDeliveryDates'"></dynamic-date-form>
            </div>
            <div class="bulk-flex">
              <div class="carrier-pickup-datenote carrier-text-alignment pickupdetails-bulk-width py-1">
                {{metadata['scheduledDelivery']}}</div>
              <div class="carrier-pickup-datenote-key dispatch-page-width">
                <simple-control [form]="f" key="scheduledDelivery" [label]="metadata['scheduledDelivery']"
                  type="text"></simple-control>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </form>
</ng-container>
<p-dialog [(visible)]="showCancelWarningDailog" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Are you sure you want to abandon this bulk dispatch? Data will not be saved.
    </div>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="showCancelWarningDailog = false;">No</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="cancel()">Yes</button>
      </div>
    </div>
  </div>
</p-dialog>

<confirm-delete-dialog
  [visible]="showDeleteWarning"
  [message]="'Are you sure you want to delete this Carrier Email?'"
  (confirm)="onDeleteConfirm($event)">
</confirm-delete-dialog>
